import { gql } from '@apollo/client';

export const LoginMutation = gql`
  mutation Login($email: String!, $password: String!, $notificationToken: String, $platform: String) {
    login(email: $email, password: $password, notificationToken: $notificationToken, platform: $platform) {
      accessToken
      refreshToken
      user {
        id
        email
        firstName
        lastName
        role
        canBrowseNas
        children {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export const ACT_AS_CHILD = gql`
  mutation ActAsChild($childId: Int!) {
    actAsChild(childId: $childId) {
      accessToken
      refreshToken
      user {
        id
        email
        firstName
        lastName
        role
        canBrowseNas
      }
    }
  }
`;

export const InviteMutation = gql`
  mutation Invite($firstName: String!, $lastName: String!, $email: String!) {
    invite(firstName: $firstName, lastName: $lastName, email: $email) {
      status
      message
    }
  }
`;

export const SignUpOnInvite = gql`
  mutation SignUpOnInvite($email: String!, $code: String!, $password: String!) {
    signUpOnInvite(email: $email, code: $code, password: $password) {
      status
      message
    }
  }
`;

export const RefreshTokenMutation = gql`
  mutation RefreshToken($refreshToken: String!, $notificationToken: String) {
    refreshToken(refreshToken: $refreshToken, notificationToken: $notificationToken) {
      accessToken
      refreshToken
      user {
        email
        firstName
        lastName
        role
        canBrowseNas
      }
    }
  }
`;

export const UploadOneFileMutation = gql`
mutation AddOneFile($file: String!, $name: String!) {
  addOneFile(file: $file, name: $name) {
    id
  }
}
`;

export const DeleteOneFileMutation = gql`
mutation DeleteOneFile($fileId: Int!) {
  deleteOneFile(fileId: $fileId) {
    id
  }
}
`;

export const UploadFileForUserMutation = gql`
mutation AddFileForUser($profileId: Int!, $file: String!, $name: String!, $type: String!) {
  addFileForUser(profileId: $profileId, file: $file, name: $name, type: $type) {
    id
  }
}
`;

export const DeleteFileForUserMutation = gql`
mutation DeleteFileForUser($profileId: Int!, $fileId: Int!) {
  deleteFileForUser(profileId: $profileId, fileId: $fileId) {
    id
  }
}
`;

export const ForgotPasswordMutation = gql`
mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email) {
    status
    message
  }
}
`;

export const ResetPasswordMutation = gql`
mutation ResetPassword($codeToken: String!, $email: String!, $password: String!) {
  resetPassword(codeToken: $codeToken, email: $email, password: $password) {
    status
    message
  }
}
`;

export const DeleteUserMutation = gql`
mutation DeleteOneUser($email: String!) {
  deleteOneUser(email: $email) {
    message
    status
  }
}
`;

export const PromoteOneUserToCompetitor = gql`
mutation PromoteOneUserToCompetitor($email: String!) {
  promoteOneUserToCompetitor(email: $email) {
    message
    status
  }
}
`;

export const DemoteCompetitorToActive = gql`
mutation DemoteCompetitorToActive($email: String!, $reason: String) {
  demoteCompetitorToActive(email: $email, reason: $reason) {
    message
    status
  }
}
`;

export const ValidateContribution = gql`
mutation ValidateContribution($userId: Int!, $seasonId: Int!) {
  validateContribution(userId: $userId, seasonId: $seasonId) {
    userId
    seasonId
    paidAt
  }
}
`;

export const RevokeContribution = gql`
mutation RevokeContribution($userId: Int!, $seasonId: Int!) {
  revokeContribution(userId: $userId, seasonId: $seasonId) {
    message
    status
  }
}
`;

export const ValidateSecurityDeposit = gql`
mutation ValidateSecurityDeposit($userId: Int!, $seasonId: Int!) {
  validateSecurityDeposit(userId: $userId, seasonId: $seasonId) {
    userId
    seasonId
    paidAt
  }
}
`;

export const RevokeSecurityDeposit = gql`
mutation RevokeSecurityDeposit($userId: Int!, $seasonId: Int!) {
  revokeSecurityDeposit(userId: $userId, seasonId: $seasonId) {
    message
    status
  }
}
`;

export const UpdateOneUser = gql`
mutation UpdateOneUser($updateOneUserId: Int!, $email: String, $lastName: String, $firstName: String, $profile: ProfileCreateInput) {
  updateOneUser(id: $updateOneUserId, email: $email, lastName: $lastName, firstName: $firstName, profile: $profile) {
    status
  }
}
`;

export const CREATE_COMPANION = gql`
  mutation CreateCompanion($firstName: String!, $lastName: String!, $email: String!, $phone: String) {
    createCompanion(firstName: $firstName, lastName: $lastName, email: $email, phone: $phone) {
      status
      message
    }
  }
`;

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($id: Int!, $role: String!) {
    updateUserRole(id: $id, role: $role) {
      status
      message
    }
  }
`;

export const CREATE_CHILD_ACCOUNT = gql`
  mutation CreateChildAccount($firstName: String!, $lastName: String!, $dateOfBirth: String!, $parentEmail: String!) {
    createChildAccount(firstName: $firstName, lastName: $lastName, dateOfBirth: $dateOfBirth, parentEmail: $parentEmail) {
      status
      message
    }
  }
`;

export const CONVERT_TO_CHILD_ACCOUNT = gql`
  mutation ConvertToChildAccount($userId: Int!, $parentEmail: String!) {
    convertToChildAccount(userId: $userId, parentEmail: $parentEmail) {
      status
      message
    }
  }
`;

export const RESEND_CHILD_INVITE = gql`
  mutation ResendChildInvite($childId: Int!) {
    resendChildInvite(childId: $childId) {
      status
      message
    }
  }
`;

export const UNLINK_CHILD_ACCOUNT = gql`
  mutation UnlinkChildAccount($childId: Int!) {
    unlinkChildAccount(childId: $childId) {
      status
      message
    }
  }
`;

export const ACCEPT_CHILD_INVITE = gql`
  mutation AcceptChildInvite($token: String!, $password: String) {
    acceptChildInvite(token: $token, password: $password) {
      status
      message
    }
  }
`;
